var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code-editor"},[_c('div',{ref:"codeMirrorContainer"}),(_vm.error)?_c('div',{staticClass:"code-editor-error",style:(_vm.errorStyle)},[_vm._v(" "+_vm._s(_vm.error.message)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }